var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63603",
    "data-name": "Group 63603",
    transform: "translate(-1527.5 -374.648)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24443",
    "data-name": "Rectangle 24443",
    width: 66,
    height: 66,
    rx: 10,
    transform: "translate(1527.5 374.648)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63697",
    "data-name": "Group 63697",
    transform: "translate(1530.907 381.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75474",
    "data-name": "Path 75474",
    d: "M16.516,24.806c-.211.788-.232.805-1.066.805-.656,0-1.311-.006-1.967,0-.475,0-.694-.22-.692-.694,0-1.139-.006-2.278,0-3.416,0-.753.109-.849.875-.865.151,0,.3-.019.522-.035V17.751q0-.517,0-1.035c0-.3.14-.552.447-.485a.652.652,0,0,1,.381.487c.034,1.189.018,2.38.02,3.571,0,.085.013.171.025.323.2.009.4.022.6.026.639.01.78.149.787.8.006.567,0,1.134,0,1.779l8.04-1.623a11.678,11.678,0,0,1,.6-2.089,3.422,3.422,0,0,1,3.232-1.946c2.5-.017,5-.009,7.5,0a3.625,3.625,0,0,1,3.736,3.764c0,.067.013.133.023.242l8.182,1.653c0-.565,0-1.091,0-1.615,0-.862.085-.948.936-.963.134,0,.268-.018.473-.032v-2.38c0-.465,0-.931,0-1.4,0-.317.031-.624.44-.612.365.012.411.3.41.6,0,1.07,0,2.139,0,3.209,0,.184,0,.369,0,.617.248,0,.432,0,.616,0,.633.009.775.137.779.751q.01,1.734,0,3.468c0,.6-.165.747-.786.752-.638.006-1.276,0-1.914,0-.783,0-.817-.027-1.02-.809-.145-.008-.3-.023-.45-.023-2.622,0-5.243.006-7.865-.007-.35,0-.5.071-.571.456q-.784,4.322-1.623,8.634A2.879,2.879,0,0,1,34.229,36.3q-2.122.01-4.243,0a2.889,2.889,0,0,1-2.966-2.434q-.835-4.339-1.635-8.684c-.051-.28-.129-.422-.449-.42-2.725.013-5.45.01-8.175.014a2.3,2.3,0,0,0-.245.025m15.575,9.549a3.187,3.187,0,1,0-3.185-3.185,3.177,3.177,0,0,0,3.185,3.185M28.6,28.2c0-.081,0-.163,0-.244-.228-.151-.444-.4-.689-.432-.346-.045-.569.217-.562.587a.514.514,0,0,0,.589.563c.241-.039.445-.307.665-.473",
    transform: "translate(-2.511 -0.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75475",
    "data-name": "Path 75475",
    d: "M43.41,15.474H55.017a8.5,8.5,0,0,0-1,1.127c-.772,1.279-2.005,1.219-3.143.957-2.462-.567-4.887-1.3-7.326-1.966-.029-.008-.05-.042-.137-.118",
    transform: "translate(-8.523 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75476",
    "data-name": "Path 75476",
    d: "M15.776,15.48H27.432a2.917,2.917,0,0,1-.363.17c-2.273.621-4.538,1.278-6.826,1.836a11.437,11.437,0,0,1-2.307.129.476.476,0,0,1-.317-.142c-.59-.624-1.169-1.26-1.844-1.993",
    transform: "translate(-3.097 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75477",
    "data-name": "Path 75477",
    d: "M.014,15.484H11.525a13.105,13.105,0,0,0-1.1,1.225,1.942,1.942,0,0,1-2.111.917c-1.075-.208-2.155-.4-3.217-.664-1.618-.405-3.222-.867-4.832-1.307A2.429,2.429,0,0,1,0,15.55l.014-.066",
    transform: "translate(0 -0.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75478",
    "data-name": "Path 75478",
    d: "M59.286,15.484H70.807c.006.031.012.062.018.092-.7.2-1.4.4-2.1.587-1.527.416-3.043.881-4.587,1.22a18.185,18.185,0,0,1-2.655.233.461.461,0,0,1-.323-.126c-.6-.632-1.193-1.276-1.871-2.007",
    transform: "translate(-11.64 -0.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75479",
    "data-name": "Path 75479",
    d: "M36.028,37.231a3.187,3.187,0,1,1,3.211-3.158,3.178,3.178,0,0,1-3.211,3.158m.027-5.236A2.054,2.054,0,1,0,38.1,34.073a2.057,2.057,0,0,0-2.048-2.078",
    transform: "translate(-6.448 -3.02)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75480",
    "data-name": "Path 75480",
    d: "M36.332,32.272a2.054,2.054,0,1,1-2.076,2.052,2.053,2.053,0,0,1,2.076-2.052m1.287,1.155c-.258-.15-.416-.317-.54-.294s-.325.24-.313.353a.486.486,0,0,0,.356.321c.125.007.26-.187.5-.38",
    transform: "translate(-6.726 -3.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75481",
    "data-name": "Path 75481",
    d: "M32.154,30.912a.628.628,0,1,1-.628-.628.628.628,0,0,1,.628.628",
    transform: "translate(-6.067 -2.908)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75482",
    "data-name": "Path 75482",
    d: "M38.231,33.768a.427.427,0,1,1-.427-.427.427.427,0,0,1,.427.427",
    transform: "translate(-7.339 -3.508)",
    fill: "#fe6831"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIcon3);
export default __webpack_public_path__ + "static/media/services-icon-3.77f793d6a62c142388a98f15fede6d88.svg";
export { ForwardRef as ReactComponent };